import axios from 'axios'

export const dashboardService = {

  /**
   * Get progress stats for all users in a Group
   *
   * @param String token
   * @param String groupId
   */
  getGroupCourseProgress (token, groupId) {
    return axios.get('/api/DashboardData/GroupCourseProgressData?GroupCourseMasterId=' + groupId, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
  },

  /**
   * Get progress stats for all users in a Cohort
   *
   * @param String token
   * @param String cohortId
   */
  getCohortProgress (token, cohortId) {
    return axios.get('/api/DashboardData/ProgressData?cohortId=' + cohortId, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
  },

  /**
   * Get progress stats for all users in a Group
   *
   * @param String token
   * @param String cohortId
   */
  getAllGroupStats (token, groupId) {
    return axios.get('/api/DashboardData/GroupProgressData?GroupId=' + groupId, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
  },

  getMentoraMomentStats (token, groupId) {
    return axios.get('/api/Report/GCCMomentsReport?GroupId=' + groupId, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
  }

  // getGCCData (token, groupId) {
  //   return axios.get('/api/DashboardData/GetGCCData?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  // }
}



// WEBPACK FOOTER //
// ./src/server-util/dashboard-service.js